import React, { useEffect, useContext, useState } from 'react'
import { useHistory, NavLink } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import ReactImgix from 'react-imgix'
import Button from '../button'
import Loader from '../loader'
import styles from './index.css'
import { useConfig } from '../../hooks/use-config'
import { getConfigValue } from '../../utils/getConfigValue'
import { UseNotFoundContext, UPDATE } from './hooks/use-not-found-context'

/**
 * A component to display 404 error
 */
const NotFound = () => {
  const [, dispatch] = useContext(UseNotFoundContext)
  const history = useHistory()
  const [counter, setCounter] = useState(5)
  const { appConfig, configLoading } = useConfig()
  const configValues = appConfig.values
  const imageSrc = getConfigValue(configValues, 'GUEST_HOME_HOTSPOT_IMAGE')
  const isConfigReady = !configLoading && Boolean(imageSrc)
  const buttonText = 'GO BACK HOME'
  const navPath = '/'
  useEffect(() => {
    dispatch({ type: UPDATE, payload: true })
  }, [])

  useEffect(() => {
    if (!isConfigReady) return undefined

    if (!counter) {
      history.push('/')
      // after redirected to home, reset `isNotFoundRendered` to false
      dispatch({ type: UPDATE, payload: false })
    }

    const setIntervalFunction = setInterval(() => {
      setCounter(counter - 1)
    }, 1000)

    return () => clearInterval(setIntervalFunction)
  }, [counter, isConfigReady])

  if (!isConfigReady) {
    return <Loader />
  }

  return (
    <>
      <Helmet>
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <div className={styles.imageContainer}>
        <ReactImgix
          className={styles.image}
          src={imageSrc}
          imgixParams={{ fit: 'crop', crop: 'bottom' }}
          sizes="100vw"
        />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.mainText}>Oops there&apos;s nothing here</div>
        <div className={styles.subText}>
          We&apos;ll send you home in&nbsp;
          <span className={styles.counter}>{counter}</span>
          &nbsp;
          {counter <= 1 ? 'second' : 'seconds'}
        </div>
        <NavLink to={navPath}>
          <Button
            className={styles.button}
            text={buttonText}
          />
        </NavLink>
      </div>
    </>
  )
}

export default NotFound
